/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1619
 */

require(/* 637 */"./1598/637")("flat")
